"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated Use Tabs from Antd
 * https://ant.design/components/tabs/
 */
exports.default = (function () { return null; });
